import React from "react";
import EventInfoButton from "../../EventInfoButton";
import PopupHeader from "../PopupHeader";
import useViewMoreFromYearData from "./useViewMoreFromYearData";

const ViewDayFromYearPopup = ({ popupData, closePopup }) => {
  const {
    selectedEvent,
    popUpContainerStyles,
    formattedStartDate,
    eventsForDay,
    setSelectedEvent,
    calendarTimezone,
    calendarLoading,
    popupRef,
  } = useViewMoreFromYearData({ popupData, closePopup });

  return (
    <div className={calendarLoading ? "loading" : ""} ref={popupRef}>
      <PopupHeader closePopup={closePopup} />
      <div
        className="px-4 pb-4 rounded-b-lg border-l border-b border-r"
        style={popUpContainerStyles}
      >
        <h1 className="text-es-normal font-es-bold mb-4">
          {formattedStartDate}
        </h1>
        {eventsForDay?.map((event) => (
          <EventInfoButton
            key={`${event.id}-${event?.instanceStartDate}`}
            event={event}
            selectedEvent={selectedEvent}
            setSelectedEvent={setSelectedEvent}
            calendarTimezone={calendarTimezone}
            closePopup={closePopup}
          />
        ))}
        {!eventsForDay?.length && (
          <div className="border-t mt-4">
            <p className="pt-4 font-normal text-gray-500">
              There are no events scheduled for this date.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewDayFromYearPopup;
